import { faChevronRight, faListOl } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../shared/styles/NewSublistItem.css";

function ChapterItem({ chapterTitle, topicsCount, questionsCount, onClick }) {
  return (
    <div
      className="d-flex justify-content-between align-items-center chapter-item"
      onClick={onClick}
    >
      <div className="d-flex">
        <div className="chapter-icon">
          <FontAwesomeIcon icon={faListOl} size="lg" />
        </div>
        <div>
          <h5>{chapterTitle}</h5>
          <p className="text-muted chapter-stats mt-1">
            {topicsCount} {topicsCount === 1 ? "topic" : "topics"},{" "}
            {questionsCount} {questionsCount === 1 ? "question" : "questions"}
          </p>
        </div>
      </div>
      <div>
        <FontAwesomeIcon icon={faChevronRight} size="lg" />
      </div>
    </div>
  );
}

export default ChapterItem;
